// components/ConfirmDeleteModal.jsx
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ConfirmDeleteModal = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('candidate.archiveConfirm', 'Confirm Archive')}</DialogTitle>
      <DialogContent>
        {t('candidate.archiveResumeMessage', 'Are you sure you want to archive this resume?')}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {t('common.delete', 'Delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
